// extracted by mini-css-extract-plugin
module.exports = {"container":"SafeEmailUpdate_container_3MIfF","goBack":"SafeEmailUpdate_goBack_bX8VB"};